import { Avatar, Button, Divider, ListItemText, Menu, MenuItem } from '@mui/material';
import { ApiRequest } from 'GlobalFunctions';
import { useEffect, useState } from 'react';
import { CiUser } from "react-icons/ci";
import { Link } from "react-router-dom";
import { useNavigate } from 'react-router-dom';


const defaultValues = {
    name: '',
    lastname: '',
    image: '',
}


export default function AccountMenu(props: any) {
    const navigate = useNavigate();


    const isLoggedIn = !!localStorage.getItem('ltkn'); // Verifica si hay token

    const [open, setOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const [formValues, setFormValues] = useState(defaultValues);

    const loadDetails = async () => {
        await ApiRequest({
            url: '/users/details',
            method: 'GET',
            setResponse: (response: any) => {
                setFormValues(response); 
            }
        });
    }

    useEffect(() => {
        const ltkn = localStorage.getItem('ltkn');

        if (ltkn) {
            loadDetails();
        }
    }, []);


    const logout = async () => {
        localStorage.removeItem('ltkn');
        localStorage.removeItem('user_id');
        localStorage.removeItem('role_id');
        window.location.href = '/';
    }

    return (
        <>
        {isLoggedIn ? (
            <>
            <Button
                variant="text"
                id='account_menu'
                onClick={(event) => {
                    setOpen(true);
                    setAnchorEl(event.currentTarget);
                }}
                sx={{ 
                    border: "none", 
                    color: 'white',
                    gap: '10px',
                }}
                
            >
                
                <div className='user_name'>{formValues.name} {formValues.lastname}</div>
                <Avatar sx={{ backgroundColor: "#428EFF" }} src={formValues.image}>
                    <CiUser size={30} />
                </Avatar>
            </Button>

            <Menu 
                anchorEl={anchorEl}
                open={open}
                onClose={() => setOpen(false)}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right', // Define que el menú se posicione desde la derecha
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right', // Hace que el menú aparezca hacia la izquierda
                }}
                sx={{ 
                    borderRadius: '20px',
                    padding: '20px',
                }}
                className='sites_dropdown_menu'
            >
                <div className='sites_dropdown_menu_sites'>
                    
                    
                    <MenuItem
                        component={Link}
                        to='/cuenta'
                        onClick={() => setOpen(false)}
                    >
                        Mi cuenta
                    </MenuItem>

                </div>
                <Divider style={{ borderColor: '#ECEBFF' }} />

                <MenuItem 
                    onClick={logout}
                    className='logout'
                >
                    <ListItemText>Cerrar sesión</ListItemText>
                </MenuItem>
            </Menu>
            </>
        ) : (
            <Button
                variant="contained"
                id='account_menu'
                onClick={() => navigate('/login')}
                sx={{ 
                    backgroundColor: '#FFFFFF',
                    border: "none", 
                    color: '#125095',
                    gap: '10px',
                    '&:hover': {
                        backgroundColor: '#125095', 
                        color: '#FFFFFF', 
                    }
                }}
            >
                Iniciar sesión
            </Button>
        )}
        </>
    );
}
